var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-uploader"},[_c('canvas',{ref:"shareCode",staticClass:"mobile-uploader__qrcode",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-uploader__text"},[_c('div',[_vm._v("微信扫一扫")]),_c('div',[_vm._v("手机照片直接上传")])])
}]

export { render, staticRenderFns }